import * as angular from 'angular';
import { Decimal } from 'decimal.js';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name bigDecimalConverterService
     * @memberof app
     *
     * @description
     * Expose one method {@link app.bigDecimalConverterService#convert} to convert JSON structures deeply.
     * `value` attributes in an object with the flag `floatingPointNumber` will be converted to decimal
     * in order to allow for proper calculations with arbitrary-precision signed decimal numbers.
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .service('bigDecimalConverterService', bigDecimalConverterService);

    function bigDecimalConverterService() {
        var FLAG_KEY_NAME = 'floatingPointNumber';
        var VALUE_KEY_NAME = 'value';

        return {
            convert: convert,
            stripThousandSeparators: stripThousandSeparators,
            FLAG_KEY_NAME: FLAG_KEY_NAME,
            VALUE_KEY_NAME: VALUE_KEY_NAME
        };

        function convert(target) {
            if (Array.isArray(target)) {
                convertForArray(target);
            } else if (angular.isObject(target)) {
                convertForObject(target);
            }
            return target;
        }

        function convertForArray(target) {
            for (var i = 0; i < target.length; i++) {
                var obj = target[i];

                if (
                    obj.hasOwnProperty(FLAG_KEY_NAME) &&
                    obj[FLAG_KEY_NAME] === true
                ) {
                    obj[VALUE_KEY_NAME] = new Decimal(obj[VALUE_KEY_NAME]);
                } else {
                    obj = convert(obj);
                }
            }

            return target;
        }

        function convertForObject(target) {
            for (var obj in target) {
                if (!target.hasOwnProperty(obj) || target[obj] === null) {
                    continue;
                }

                if (
                    target[obj].hasOwnProperty(FLAG_KEY_NAME) &&
                    target[obj][FLAG_KEY_NAME] === true
                ) {
                    target[obj][VALUE_KEY_NAME] = new Decimal(
                        target[obj][VALUE_KEY_NAME]
                    );
                } else {
                    target[obj] = convert(target[obj]);
                }
            }

            return target;
        }

        function stripThousandSeparators(str) {
            return str.split(',').join('');
        }
    }
})();
